enum ClientStatus {
  ACTIVE = 'Active',
  HOSPITALIZED = 'Hospitalized',
  INCARCERATED = 'Incarcerated',
  DILIGENT_SEARCH = 'DiligentSearch',
  REHABILITATION = 'Rehabilitation',
}

export default ClientStatus;
